import Vue from 'vue'
import Vuex from 'vuex' 
Vue.use(Vuex);


const state = {
    // 城市名称
    cityName: "北京",
    // 城市code值
    cityCode: "2",
    // 电影ID
    movieId: null,
    // 影院ID
    cinemaId: null,
    //是否是热映
    isHotMovie:''
}

const getters = {
    // 时时监听state值
    city:(state) => {
        return state.a + 1
    }
}

const mutations = {        
    getCityInfo:(state,value) => {
        state.cityName = value.shortName;
        state.cityCode = value.code;
    },
    getMovieId:(state,value) => {
        state.movieId = value
    },
    getCinemaId:(state,value) =>{
        localStorage.cinemaId = value
        state.cinemaId = localStorage.cinemaId
    },
    getHotStatus:(state,isHotMovie) =>{
        state.isHotMovie = isHotMovie
    }
}
const actions = {

}

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions

});
 
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js